exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".echarts{width:100%;height:5.333333rem}", ""]);

// exports
